import React from 'react';

export const RouterContext = React.createContext({
	route: '',
	setRoute: () => {}
});